<template>
  <div class="kariInput">
    <p class="label" v-bind:class="{ labelError: errorCode > 0 }">{{label}}</p>
    <input
      v-if="mask.length === 0"
      v-bind:class="{ errInput: errorCode > 0 }"
      :placeholder="placeholder"
      v-model="value"
      :type="type"
    >

    <MaskInput
      v-bind:class="{ errInput: errorCode > 0 }"
      v-else
      :mask="mask"
      v-model="value"
    />

  </div>
</template>

<script>
export default {
  name: 'text-input',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      errorCode: 0,
      placeholder: '_______'
    };
  },
  computed: {
    value: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style scoped>
.kariInput { width: 100% }
.kariInput>.label { font-size: 4.27vw; line-height: 6.40vw; color: rgba(153, 153, 153, 1); margin-bottom: 1.07vw }
.kariInput>.label.labelError { color: rgba(255, 87, 87, 1) }
.kariInput>.errInput { border: 1px solid rgba(255, 87, 87, 1) }
.kariInput>input { line-height: 6.67vw; font-size: 4.53vw; border-radius: 8px; border: 1px solid rgba(207, 207, 207, 1); padding: 3.20vw 2.13vw; width: calc(100% - 4.27vw); background-color: rgba(245, 245, 245, 1) }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  .kariInput {}
  .kariInput>.label { font-size: 16px; line-height: 24px; margin-bottom: 4px }
  .kariInput>.label.labelError {}
  .kariInput>.errInput {}
  .kariInput>input { line-height: 25px; font-size: 17px; padding: 12px 8px; width: calc(100% - 16px) }
}

</style>
